import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const DataPage_RunFixtures_Mutation = graphql(`
  mutation DataPage_RunFixtures($dataSet: DataSetEnum!) {
    runFixtures(dataSet: $dataSet) {
      status
    }
  }
`);

export const useRunFixturesMutation = () =>
  useGraphQLMutation(DataPage_RunFixtures_Mutation);
